module.exports = __webpack_public_path__ + "static/media/5RecepcionFacturasAutenticacionExitosa.c10db9c0.png";